import Loading from '@/common/components/atom/loading';
import type { SVGProps } from 'react';

export type LauncherIconsLoaderIconProps = SVGProps<SVGSVGElement> & { title?: string };

// Keep existing imports and layout classes while sharing the patient loading indicator.
export function LauncherIconsLoaderIcon(props: LauncherIconsLoaderIconProps) {
  return <Loading width="1em" height="1em" {...props} />;
}

export default LauncherIconsLoaderIcon;
